import { render } from "./AdminPanel.vue?vue&type=template&id=7b1f3890&scoped=true"
const script = {}

import "./AdminPanel.vue?vue&type=style&index=0&id=7b1f3890&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b1f3890"]])

export default __exports__